import * as React from 'react';
import { SVGProps } from 'react';

const IconGeoSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12s4-4 4-7c0-2.301-1.79-4-4-4S2 2.699 2 5c0 3 4 7 4 7zm0-5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
    />
  </svg>
);
export default IconGeoSizeXs;
